import { toArray } from 'lodash'
import { mapLanguage } from 'Lib/i18nMiddleware'
import { SET_LANGUAGE } from './config'

export const TEAM_FETCH_LIST_REQUEST = 'TEAM::FETCH_LIST_REQUEST'
export const TEAM_FETCH_LIST_FAIL = 'TEAM::FETCH_LIST_FAIL'
export const TEAM_FETCH_LIST_SUCCESS = 'TEAM::FETCH_LIST_SUCCESS'

const initialState = { list: [], default: [], fetching: false }

export const fetchTeam = () => ({
  type: TEAM_FETCH_LIST_REQUEST,
})

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case TEAM_FETCH_LIST_REQUEST: {
      return {
        ...state,
        fetching: true,
      }
    }
    case TEAM_FETCH_LIST_SUCCESS: {
      return {
        ...state,
        list: toArray(action.data).map(mapLanguage(action.lang)),
        default: toArray(action.data),
        fetching: false,
      }
    }
    case TEAM_FETCH_LIST_FAIL: {
      return {
        ...state,
        list: [],
        fetching: false,
      }
    }
    case SET_LANGUAGE: {
      return {
        ...state,
        list: state.default.map(mapLanguage(action.payload.lang)),
      }
    }
    default:
      return state
  }
}

export default reducer
